import { Component, OnInit } from '@angular/core';
import { ContentComponent } from '../../layouts/content/content.component';
import { cmsService } from "../../service/cmsService";
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { HttpErrorResponse } from '@angular/common/http';
@Component({
  selector: 'app-page',
  templateUrl: './page.component.html',
  styleUrls: ['./page.component.css'],
  providers:[ContentComponent]
})
export class PageComponent implements OnInit {
  pageData:any;
  msg="";
  constructor(public router: Router,private route:ActivatedRoute,private contentComponent:ContentComponent,private _cms:cmsService) { }

  ngOnInit() {
    this.getPageDetail();
   
  }


  ngAfterViewInit() {
   
   
  }

  getPageDetail(){
    var slug=this.router.url.replace("/page/", "");
    this._cms.detail(slug).subscribe((data : any)=>{
        // console.log("load");
         //console.log(data);
         if(data.error==0){
          this.pageData= data;
         // console.log(this.pageData);
         }else if(data.status==404){
          this.pageData.data={}         
         }
         
    },
    (error : HttpErrorResponse)=>{
      //console.log("error");
       this.msg="internal server error!";
    });
    
    
        }

}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/home/page/page.component.ts